type DesktopAuthHost = {
  electronAPI?: {
    getDesktopInstanceId?: (legacyRendererId?: string) => Promise<string>;
  } | null;
} | null;

export type EnterpriseDesktopAuthInfo = {
  token: string;
  username: string;
  email: string;
  user_id: number;
};

const DEFAULT_DESKTOP_INSTANCE_ID = 'keystone-desktop';
const LEGACY_DESKTOP_TOKEN_PREFIX = 'keystone-desktop-';

export function isEnterpriseDesktopAuthAvailable(
  isDesktopHost: boolean,
  hasStackKeys: unknown
): boolean {
  return isDesktopHost && !hasStackKeys;
}

export function userIdFromDesktopInstanceId(desktopInstanceId: string): number {
  let hash = 0;
  for (let index = 0; index < desktopInstanceId.length; index += 1) {
    hash = (hash * 31 + desktopInstanceId.charCodeAt(index)) >>> 0;
  }
  return hash || 1;
}

export function isLegacyEnterpriseDesktopToken(token: unknown): boolean {
  return (
    typeof token === 'string' && token.startsWith(LEGACY_DESKTOP_TOKEN_PREFIX)
  );
}

export function buildEnterpriseDesktopAuthInfo(
  desktopInstanceId: string
): EnterpriseDesktopAuthInfo {
  const normalizedInstanceId =
    desktopInstanceId.trim() || DEFAULT_DESKTOP_INSTANCE_ID;
  const userId = userIdFromDesktopInstanceId(normalizedInstanceId);

  return {
    token: `keystone-desktop-${normalizedInstanceId}`,
    username: 'Keystone 企业用户',
    email: `desktop-${userId}@keystone.local`,
    user_id: userId,
  };
}

export async function resolveEnterpriseDesktopAuthInfo(
  host: DesktopAuthHost
): Promise<EnterpriseDesktopAuthInfo> {
  const desktopInstanceId =
    (await host?.electronAPI?.getDesktopInstanceId?.().catch(() => null)) ||
    DEFAULT_DESKTOP_INSTANCE_ID;

  return buildEnterpriseDesktopAuthInfo(desktopInstanceId);
}
